module.exports = __webpack_public_path__ + "static/VBMC-bb7c822b7f0e53a6d1618ff1dd1bb780.png";